
interface WaveDividerProps {
  topColor?: string;
  bottomColor?: string;
  variant?: 1 | 2 | 3 | 4;
  height?: number;
  flip?: boolean;
}

export default function WaveDivider({
  topColor = '#ffffff',
  bottomColor = '#ffffff',
  variant = 1,
  height = 80,
  flip = false,
}: WaveDividerProps) {
  const getWavePaths = () => {
    switch (variant) {
      case 1:
        return {
          back: 'M0,55 C200,10 400,90 600,45 C800,0 1000,80 1200,40 C1320,20 1380,60 1440,50 L1440,100 L0,100 Z',
          front: 'M0,65 C180,20 360,95 540,55 C720,15 900,85 1080,50 C1260,15 1380,70 1440,60 L1440,100 L0,100 Z',
        };
      case 2:
        return {
          back: 'M0,40 C240,90 480,10 720,55 C960,100 1200,20 1440,60 L1440,100 L0,100 Z',
          front: 'M0,55 C200,5 440,85 680,45 C920,5 1160,80 1440,45 L1440,100 L0,100 Z',
        };
      case 3:
        return {
          back: 'M0,50 C120,90 240,20 360,60 C480,100 600,25 720,65 C840,100 960,30 1080,65 C1200,100 1320,40 1440,55 L1440,100 L0,100 Z',
          front: 'M0,65 C150,15 300,90 450,50 C600,10 750,80 900,45 C1050,10 1200,75 1350,50 C1400,40 1430,55 1440,60 L1440,100 L0,100 Z',
        };
      case 4:
        return {
          back: 'M0,35 C300,85 600,5 900,60 C1100,95 1300,25 1440,50 L1440,100 L0,100 Z',
          front: 'M0,55 C250,10 500,90 750,45 C1000,0 1250,80 1440,40 L1440,100 L0,100 Z',
        };
      default:
        return {
          back: 'M0,55 C200,10 400,90 600,45 C800,0 1000,80 1200,40 C1320,20 1380,60 1440,50 L1440,100 L0,100 Z',
          front: 'M0,65 C180,20 360,95 540,55 C720,15 900,85 1080,50 C1260,15 1380,70 1440,60 L1440,100 L0,100 Z',
        };
    }
  };

  const paths = getWavePaths();

  return (
    <div
      className="relative w-full overflow-hidden"
      style={{ height: `${height}px`, backgroundColor: bottomColor }}
    >
      <style>{`
        @keyframes waveSlide1 {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes waveSlide2 {
          0%   { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>

      {/* Onda trasera (más lenta, semitransparente) */}
      <div className="absolute inset-0" style={{ opacity: 0.45 }}>
        <div
          style={{
            width: '200%',
            height: '100%',
            animation: 'waveSlide2 22s linear infinite',
          }}
        >
          <svg
            viewBox="0 0 2880 100"
            preserveAspectRatio="none"
            style={{ width: '100%', height: `${height}px`, display: 'block' }}
          >
            <path d={paths.back} fill={topColor} />
            <path d={paths.back} fill={topColor} transform="translate(1440,0)" />
          </svg>
        </div>
      </div>

      {/* Onda delantera (más rápida, opaca) */}
      <div className="absolute inset-0">
        <div
          style={{
            width: '200%',
            height: '100%',
            animation: 'waveSlide1 14s linear infinite',
          }}
        >
          <svg
            viewBox="0 0 2880 100"
            preserveAspectRatio="none"
            style={{ width: '100%', height: `${height}px`, display: 'block' }}
          >
            <path d={paths.front} fill={topColor} />
            <path d={paths.front} fill={topColor} transform="translate(1440,0)" />
          </svg>
        </div>
      </div>
    </div>
  );
}
